import { ShoppingCartOutlined } from "@ant-design/icons"
import { Badge, Col, Divider, Row, Tabs, Typography } from "antd"
import React, { useState } from "react"
import AllOrdersTable from "./AllOrdersTable"
import CompletedOrders from "./CompletedOrders"
import WarehouseOrders from "./WarehouseOrders"
import useDoneOrders from "../../../store/SidebarNotifs/useDoneOrders"
import TapeOrders from "./TapeOrders"
import { useCollection } from "../../../hooks/useCollection"
import { useAuthContext } from "../../../hooks/useAuthContext"
import ArsomaTable from "./ArsomaTable"
import VivaTable from "./VivaTable"
import WinderTable from "./WinderTable"
import WarehouseAwaitingDocument from "./WarehouseAwaitingDocument"
import useAwaitingDocWarehouse from "../../../store/SidebarNotifs/useAwaitingDocWarehouse"
import PrePayment from "./PrePayment"
import usePrePaymentOrders from "../../../store/SidebarNotifs/usePrePaymentOrders"
import useFetchTicketsHoldOrders from "../../../store/Tickets/useFetchTicketHoldOrders"
import TicketHoldOrders from "../../../components/Tickets/TicketHoldOrders"

const { Title } = Typography

export default function AllOrders() {
  //get warehouse orders
  const { doneOrders, loading: doneOrdersLoading } = useDoneOrders((state) => state)
  const { ticketsHoldOrderCount, loading: holdOrdersLoading } = useFetchTicketsHoldOrders()

  //awaiting warehouse orders
  const {
    awaitingDocWarehouseOrders,
    loading: awaitingWarehouseDocOrdersLoading,
    awaitingDocWarehouseOrdersCount,
  } = useAwaitingDocWarehouse((state) => state)

  //get pre payment orders
  const {
    prePaymentOrders,
    loading: prePaymentsLoading,
    prePaymentOrdersCount,
  } = usePrePaymentOrders((state) => state)

  const { user } = useAuthContext()

  const { loading, data } = useCollection(
    "orders",
    ["uid", "==", user.uid],
    ["orderStatus", "<=", 6],
  )

  const [currentKey, setCurrentKey] = useState(1)

  const onChange = (key) => {
    setCurrentKey(key)
    console.log(key)
  }

  const items = [
    {
      key: 0,
      label: (
        <Badge count={prePaymentOrdersCount} size="large" offset={[10, 0]} overflowCount={999}>
          Pre Payment
        </Badge>
      ),
      children: <PrePayment data={prePaymentOrders} loading={prePaymentsLoading} />,
    },
    {
      key: "1",
      label: `Active Orders (mine)`,
      children: <AllOrdersTable loading={loading} data={data} />,
    },
    {
      key: 2,
      label: `Tape (printing)`,
      children: <TapeOrders activeKey={currentKey} user={user} />,
    },
    {
      key: 3,
      label: `Arsoma (printing)`,
      children: <ArsomaTable user={user} currentKey={currentKey} />,
    },
    {
      key: 4,
      label: `Viva (printing)`,
      children: <VivaTable user={user} currentKey={currentKey} />,
    },
    {
      key: 4.5,
      label: `Winder (printing)`,
      children: <WinderTable user={user} currentKey={currentKey} />,
    },
    {
      key: 5,
      label: (
        <Badge
          count={awaitingDocWarehouseOrdersCount}
          size="large"
          offset={[10, 0]}
          overflowCount={999}>
          "Warehouse (Awaiting Document)"
        </Badge>
      ),
      children: (
        <WarehouseAwaitingDocument
          initialData={awaitingDocWarehouseOrders}
          loading={awaitingWarehouseDocOrdersLoading}
        />
      ),
    },
    {
      key: 5.5,
      label: "Warehouse",
      children: <WarehouseOrders initialData={doneOrders} loading={doneOrdersLoading} />,
    },
    {
      key: 6,
      label: (
        <Badge
          count={holdOrdersLoading ? 0 : ticketsHoldOrderCount}
          size="large"
          offset={[10, 0]}
          overflowCount={999}>
          Orders on Hold
        </Badge>
      ),
      children: <TicketHoldOrders forManager={true} />,
    },
    // {
    //   key: 6,
    //   label: (
    //     <Badge count={ticketsHoldOrderCount} size="large" offset={[10, 0]} overflowCount={999}>
    //       Orders on Hold
    //     </Badge>
    //   ),
    //   children: <DeliveryAndPayment currentKey={currentKey} />,
    // },
    {
      key: 7,
      label: `Completed`,
      children: <CompletedOrders currentKey={currentKey} />,
    },
  ]

  return (
    <div>
      <Row gutter={[0, 15]}>
        <Col span={24}>
          <div style={{ padding: 15 }}>
            <Title level={3}>
              <ShoppingCartOutlined />
              <Divider type="vertical" />
              My Orders
            </Title>
          </div>
        </Col>
      </Row>

      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </div>
  )
}
